
export function getHomeArtisList() {
  return (dispatch, getState) => {
    let listArtist
    fetch("https://www.theaudiodb.com/api/v1/json/1/search.php?s=coldplay")
      .then((resp) => resp.json())
      .then((artist) => {
        listArtist = artist.artists
        return fetch("https://www.theaudiodb.com/api/v1/json/1/search.php?s=adele")
      })
      .then((resp) => resp.json())
      .then((artist) => {
        listArtist.push(artist.artists[0])
        return fetch("https://www.theaudiodb.com/api/v1/json/1/search.php?s=metallica")
      })
      .then((resp) => resp.json())
      .then((artist) => {
        listArtist.push(artist.artists[0])
        return fetch("https://www.theaudiodb.com/api/v1/json/1/search.php?s=bruno_mars")
      })
      .then((resp) => resp.json())
      .then((artist) => {
        listArtist.push(artist.artists[0])
        dispatch({
          type: "ADD_LIST_HOME",
          payload: listArtist
        })
      })
      .catch(err => {
        console.log(err);
      })
  }
}